import { SpreadDesignTemplate } from 'editor/src/store/editorModules/templates/types';
import { RootState } from 'editor/src/store/index';

function getTemplates(state: RootState): SpreadDesignTemplate[] {
  return state.editorModules.templates.designTemplates;
}

export default getTemplates;
